import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pcs-accordion-panel-content',
  templateUrl: './accordion-panel-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionPanelContentComponent {

}
